import CellRender from './cell-render'

export default {
    inject: ['cell'],

    inheritAttrs: false,

    components: {
        CellRender
    },

    props: {
        row: {
            type: Object,
            required: true
        },
        column: {
            type: Object,
            required: true
        },
        // 可指定字段名
        field: {
            type: String,
        },
        index: Number,
        cellEditing: {
            type: Boolean,
            required: true
        },
        cellEditable: {
            type: Boolean,
            default: false,
        },
        node: {
            type: Object,
        },
        // 自定义只读模式下的渲染方式
        render: {
            type: Function
        },
    },

    data() {
        return {
            oldValue: ""
        }
    },

    computed: {
        prefixCls() {
            return 'ivu-cell-edit'
        },
        key() {
            return this.field || this.column.key || ''
        },
        value() {
            return this.row[this.key]
        },
        align() {
            return this.column ? this.column.align : 'left'
        },
        editEvents() {
            var on = this.$listeners || {},
                events = {},
                me = this

            // proxy event handler
            Object.keys(on).forEach(name => {
                var handler = on[name]

                events[name] = function() {
                    // 让事件参数携带上下文信息
                    handler(...arguments, me.getContext())
                }
            })

            return events
        }
    },

    methods: {
        onChange(val) {
            this.oldValue = this.value
            this.cell.editCellChange(this.key, val)

            if (this.editEvents["input"]) {
                this.editEvents["input"](val)
            }
        },

        getContext() {
            return {
                row: this.row,
                column: this.column,
                index: this.index,
                node: this.node,
                value: this.value,
                oldValue: this.oldValue
            }
        }
    },

    created() {
        this.oldValue = this.row[this.key]
    }
}